import React from 'react'
import { Form, Select } from 'antd'

const { Option } = Select

const LoadFilter = ({ form, fieldKey, filters, label="FILTER" }) => {
	const { getFieldDecorator } = form
	return (
		<Form.Item label={label}>
			{getFieldDecorator(fieldKey, {
				validateTrigger: ['onChange', 'onBlur'],
				rules: [
					{
						required: true,
						message: 'Required'
					}
				]
			})(
				<Select placeholder="Load Existing Filter">
					{filters.map(item => (
						<Option key={item.id} value={item.id}>
							{item.name}
						</Option>
					))}
				</Select>
			)}
		</Form.Item>
	)
}

export default LoadFilter
